import React, { useState, useEffect } from 'react';
import Footer from './footer';
import Header from './header';
import apiUrl from './base_url';
import axios from 'axios';
import ReactHtmlParser from 'react-html-parser';

import '../components/cssfile/allseries.css';

const Allseries = () => {
  const [addcategory, setAddcategory] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(apiUrl + 'serverside/parentcategory.php')
      .then(response => {
        setAddcategory(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }, []);

  /*
   * ORIGINAL LOGIC PRESERVED
   */
  const addSeries = (event, category) => {
    event.preventDefault();

    const regid = localStorage.getItem('regid');

    if (!regid) {
      window.location.href = '/login';
      return;
    }

    axios
      .post(apiUrl + 'serverside/addseries.php', {
        category,
        regid
      })
      .then(() => {
        window.location.href = '/dashboard';
      })
      .catch(error => {
        console.log(error);
        alert(error);
      });
  };

  /*
   * ORIGINAL FILTER LOGIC PRESERVED
   */
  const filteredSeries = addcategory.filter(item =>
    item.status == 1 &&
    item.topic_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="allseries-page">

      <Header />

      {/* ================= HERO ================= */}

      <section className="allseries-hero">
        <div className="allseries-hero-content">

          <span className="allseries-eyebrow">
            ERWATODAY TEST LIBRARY
          </span>

          <h1>
            Explore Test Series
          </h1>

          <p>
            Choose your preferred test series and start
            practicing with focused online mock tests.
          </p>

        </div>
      </section>


      {/* ================= CONTENT ================= */}

      <main className="allseries-container">

        {/* Header */}

        <div className="allseries-header">

          <div className="allseries-heading">

            <span className="allseries-label">
              AVAILABLE SERIES
            </span>

            <h2>
              Online Mock Test Series
            </h2>

            <p>
              Find the right test series for your preparation.
            </p>

          </div>

          {/* Search */}

          <div className="allseries-search">

            <span className="allseries-search-icon">
              🔍
            </span>

            <input
              type="text"
              placeholder="Search test series..."
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(e.target.value)
              }
            />

            {searchTerm && (
              <button
                type="button"
                className="allseries-search-clear"
                onClick={() => setSearchTerm('')}
                aria-label="Clear search"
              >
                ×
              </button>
            )}

          </div>

        </div>


        {/* Result Count */}

        {!isLoading && filteredSeries.length > 0 && (
          <div className="allseries-result-count">
            <span>
              {filteredSeries.length}
            </span>

            {filteredSeries.length === 1
              ? ' test series available'
              : ' test series available'}
          </div>
        )}


        {/* ================= SERIES ================= */}

        {isLoading ? (

          <div className="allseries-loading">

            <div className="allseries-spinner" />

            <h3>
              Loading test series...
            </h3>

            <p>
              Please wait while we load the available series.
            </p>

          </div>

        ) : filteredSeries.length > 0 ? (

          <div className="allseries-list">

            {filteredSeries.map((item, index) => (

              <article
                key={index}
                className="allseries-card"
              >

                {/* Number */}

                <div className="allseries-number">
                  {String(index + 1).padStart(2, '0')}
                </div>


                {/* Image */}

                <div className="allseries-image-wrapper">

                  <img
                    src={item.image}
                    alt={item.topic_name}
                    className="allseries-image"
                  />

                  <span className="allseries-status">
                    Available
                  </span>

                </div>


                {/* Content */}

                <div className="allseries-card-content">

                  <span className="allseries-card-label">
                    MOCK TEST SERIES
                  </span>

                  <h3>
                    {item.topic_name}
                  </h3>

                  <div className="allseries-description">
                    {ReactHtmlParser(item.total_set)}
                  </div>

                </div>


                {/* Action */}

                <div className="allseries-card-action">

                  <button
                    type="button"
                    className="allseries-start-button"
                    onClick={(e) =>
                      addSeries(
                        e,
                        item.category
                      )
                    }
                  >
                    <span>
                      Get Started
                    </span>

                    <span className="allseries-arrow">
                      →
                    </span>
                  </button>

                </div>

              </article>

            ))}

          </div>

        ) : (

          <div className="allseries-empty">

            <div className="allseries-empty-icon">
              🔍
            </div>

            <h3>
              No Test Series Found
            </h3>

            <p>
              We couldn't find a test series matching
              "{searchTerm}".
            </p>

            {searchTerm && (
              <button
                type="button"
                className="allseries-reset-button"
                onClick={() => setSearchTerm('')}
              >
                Clear Search
              </button>
            )}

          </div>

        )}

      </main>


      <Footer />

    </div>
  );
};

export default Allseries;